import { Space, List } from "../components/Layout";
import { Head } from "../components/Project";
import { Texts, Media } from "../components/Object";
import { Scroll } from "../components/Animation";

const About = () => {
  return(
    <>
      <Head slug="about"></Head>
      <div className="p-box__wrap--about">
        <div className="l-row">
          <Space size={['96px', '72px']}></Space>
          <Scroll state="left">
            <Texts slug={`page-about/title`} class={''} />
          </Scroll>
          <Space size={['48px', '40px']}></Space>
          <Texts slug={`page-about/body`} class={''} />
          <Space size={['80px', '64px']}></Space>
        </div>

        <div className="c-grid__list--about">
          <List Item={Item} length={4}></List>
        </div>

        <Space size={['120px', '80px']}></Space>
      </div>

      <Space size={['184px', '120px']}></Space>
    
      
      <div className="l-row">
        <div className="c-grid__repeat--2 c-grid__gap--64">
          <List Item={ReasonItem} length={4}></List>
        </div>
      </div>

      <Space size={['240px', '160px']}></Space>
    </>
  )
}

const Item = (props) => {
  let position = (props.index % 2) ? 'left' : 'right';
  return (
    <>
      <div className="l-row" data-state={position}>
        <Scroll state={position}>
          <Media src={`page-about/list${props.index}`} alt={'media'} class={`p-img__about-list`} state={position} />
        </Scroll>
        <Scroll>
        <div className="p-box__items--about" data-state={position}>
          <Space size={['56px', '48px']}></Space>
            <Space size={['0 0 32px', '0 0 24px']}>
              <Texts slug={`page-about/list-title${props.index}`} class={''} />
            </Space>
            <Texts slug={`page-about/list-body${props.index}`} class={''} />
          <Space size={['56px', '48px']}></Space>
        </div>
        </Scroll>
      </div>
    </>
  );
};

const ReasonItem = (props) => {
  return (
    <>
      <div className="p-box__items--reason" data-state="page">
        <Texts
          slug={`page-about/reason-list-number${props.index}`}
          class="p-box__items--reason__number c-text--big c-text--en"
          data-state="page"
        ></Texts>
        <Space size={["0 auto", "0 auto"]}>
          <Media
            src={`reason/list${props.index}`}
            alt="media"
            class="p-img__reason"
            state="page"
          ></Media>
        </Space>
        <Space size={["32px auto 32px", "24px auto 24px"]}>
          <Texts
            slug={`page-about/reason-list-title${props.index}`}
            class="c-text--center c-text__title-middle"
          ></Texts>
        </Space>
        <Texts slug={`page-about/reason-list-body${props.index}`}></Texts>
      </div>
    </>
  );
};

export default About;